import React from 'react';
import NotesMainPanel from '../../components/workspace/NotesMainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function SettingsAuditLogsPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const items = data?.workspace?.auditLogs || [];
  return (
    <NotesMainPanel
      title={t('settingsPages.auditTitle')}
      subtitle={t('settingsPages.auditSubtitle')}
      items={items}
      emptyTitle={t('settingsPages.auditEmpty')}
    />
  );
}
